import * as actions from '../actions/app';
import { put } from "redux-saga/effects";

export function* windowResize({width}){
    yield put(actions.setWindowSize(width));
}

